import { PanelType } from '../../../../../../panels/types';

export const dynamicPathPanelType: PanelType<DynamicPathPluginData> = {
  name: 'DYNAMIC_PATH_PANEL',
  location: 'left',
};
